import { Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectorRef,
  ChangeDetectionStrategy, inject, DestroyRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GtwSnackbarService } from '../../../../shared/_services/gtw-snackbar.service';
import { ConfirmationModalConfig } from '../../../../shared/components/confirmation-modal/confirmation-modal.component';
import { GlobalService } from '../../../../global/services/global.service';
import { WorkspaceService } from '../../../../workspace/workspace.service';
import { AppService } from '../../../../app.service';
import {
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
} from '../../../../shared/workspace-element-context';
import { CbcCbyeRefreshService } from './cbc-cbye-refresh.service';

@Component({
  selector: 'gtw-cbc-cbye-refresh',
  templateUrl: './cbc-cbye-refresh.component.html',
  styleUrls: ['./cbc-cbye-refresh.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CbcCbyeRefreshComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private readonly subs = new Subscription();

  confirmConfig: ConfirmationModalConfig = {
    title: 'Confirm Refresh',
    message: 'Are you sure you want to refresh the data?',
    iconClass: 'fa fa-sign-out',
    iconColor: 'txt-color-orange-dark',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    confirmButtonClass: 'btn-danger',
    cancelButtonClass: 'btn-default',
    showCancelButton: true,
    showConfirmButton: true,
    animationClass: 'animated fadeIn fast',
    loading: false,
    loadingText: 'Processing...',
  };

  filterParams: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};
  globalService: any = {};

  constructor(
    private cbyeRefreshService: CbcCbyeRefreshService,
    private gtwSnackbarService: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.globalService = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.USER_SETTINGS = this.gtwApp.USER_SETTINGS || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    this.cdr.markForCheck();
  }

  private get ssoId(): string {
    return this.USER_SETTINGS?.user?.sso_id ?? '';
  }

  private get baseUrl(): string {
    return this.GENERAL_CONFIG?.base_url ?? '';
  }

  onConfirm(): void {
    this.gtwSnackbarService.openSnackBar('Data refresh is In-Progress.', 'gtw-snackbar--green');
    this.cancel();

    this.cbyeRefreshService
      .refreshCbyeData(this.baseUrl, this.ssoId, this.filterParams, this.globalService).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          if (response?.callSuccess === '1') {
            this.gtwSnackbarService.openSnackBar(
              'Data is successfully refreshed.',
              'gtw-snackbar--green'
            );
          } else if (response?.errorMessage) {
            this.gtwSnackbarService.openSnackBar(response.errorMessage, 'gtw-snackbar--red');
          }
        },
        error: (err) => {
          this.gtwSnackbarService.openSnackBar(
            err?.message || 'Error refreshing data, please try again!',
            'gtw-snackbar--red'
          );
        },
      });
  }

  onCancel(): void {
    this.cancel();
  }

  private cancel(): void {
    const updateEvent = new CustomEvent('request-grid-update', {
      detail: 'cancel',
      bubbles: true,
    });
    document
      .querySelector('gtw-cbc-cbye-refresh-ce')
      ?.dispatchEvent(updateEvent);
  }
}
